import actionTypes from '../constants/action-types';

const unpublishWebsite = (redirectUrl = null) => ({
  type: actionTypes.UNPUBLISH_WEBSITE,
  payload: { redirectUrl },
});

export default unpublishWebsite;
